// extracted by mini-css-extract-plugin
export default {"container":"servicesPage_container__eF3AB","content":"servicesPage_content__3uwPt"};